import angular from 'angular';
import EventBus from './services/eventbus';

export default angular.module('app.core', []).service('EventBus', EventBus).name;
